import { JsonDiffController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * JSON Diff component that compares two JSON objects and displays differences in a table format.
 * Uses json-diff-ts package for comparison.
 * <salaxy-json-diff json="json" compareTo="compareTo" excludePaths="excludePaths" openApi="openApi" itemType="itemType"></salaxy-json-diff>
 */
export class JsonDiff extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
        /** JSON object to compare */
        json: "<",
        /** JSON object to compare to */
        compareTo: "<",
        /** exclude paths from the diff */
        excludePaths: "<",
        /** URL for the Open API document that contains the definition for the type. */
        openApi: "<",
        /** The type of the item to diff */
        itemType: "<"
    };

    /** Uses the JsonDiffController */
    public controller = JsonDiffController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/helpers/JsonDiff.html";
}
